import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-learn-more-travel-insurance',
  templateUrl: './learn-more-travel-insurance.component.html',
  styleUrls: ['./learn-more-travel-insurance.component.scss']
})
export class LearnMoreTravelInsuranceComponent implements OnInit {

  @Input('data') data: any;
  constructor(
    private modalController: ModalController,) { }

  ngOnInit(): void {
  }

  dismiss() {
    this.modalController
      .dismiss({
        dismissed: true,
      })
  }


}
